export default class pdfDownload {
    constructor() {
        return {
            restrict: 'E',
            scope: {},
            template: require('../../../../views/browser/pdf-download.html'),
            controller: PdfCtrl,
            controllerAs: 'downloader'
        }
    }
}

class PdfCtrl {
    constructor($scope, $element, $attrs, $window, $location) {
        this._scope = $scope;
        this._element = $element;
        this._window = $window;
        this._location = $location;

        this._element.addClass("container-fluid");
        this._scope.isProcessing = false;

        this.htmlSource = $attrs['htmlSource'];
        this.iframeEl = document.createElement('iframe');
        this.iframeEl.style.display = "none";
        document.body.appendChild(this.iframeEl);

        angular.element($window).bind('resize', this.applyStyles);

        this.applyStyles();
    }

    applyStyles() {
        $(this._element).css("width", "100%");
        $(this._element).css("position", window.innerWidth > 982 ? 'fixed' : 'relative');
    }

    downloadClick() {
        this.isProcessing = true;
        this.iframeEl.src = this.htmlSource;

        this.iframeEl.onload = (() => {
            this.isProcessing = false;
            this._scope.$apply();

            this.iframeEl.contentWindow.print();
        }).bind({ scope: this._scope });
    }

    getEncryption() {
        let url = this._location.absUrl();
        let start = url.indexOf('browser/');
        return url.substring(start + 8, url.length).replace(/\//g, '__SLASH__');
    }
}

/*(function () {
    angular.module('InBrowserApp').directive('pdfDownload', pdfDownload);

    pdfDownload.$inject = ['$location', '$window'];

    function pdfDownload($location, $window) {
        return {
            restrict: 'E',
            scope: {
            },
            templateUrl: '/views/inbrowser/pdf-download.html',
            link: linkFn
        };

        function linkFn($scope, element, attrs) {
            element.addClass("container-fluid");

            var htmlSource = attrs['htmlSource'];
            $scope.isProcessing = false;
            $scope.downloadClick = downloadClick;
            angular.element($window).bind('load', applyStyles);
            angular.element($window).bind('resize', applyStyles);

            var iframeEl = document.createElement('iframe');
            iframeEl.style.display = "none";
            document.body.appendChild(iframeEl);

            function applyStyles() {
                element.css("width", "100%");

                if ($window.innerWidth > 982) {
                    element.css("position", "fixed");
                } else {
                    element.css("position", "relative");
                }
            }

            function downloadClick() {
                $scope.isProcessing = true;
                iframeEl.src = htmlSource;

                iframeEl.onload = (function() {
                    this.scope.isProcessing = false;
                    this.scope.$apply();
                    iframeEl.contentWindow.print();
                }).bind({scope: $scope});
            }

            function getEncryption() {
                var url = $location.absUrl();
                var start = url.indexOf('browser/');
                return url.substring(start + 8, url.length).replace(/\//g, '__SLASH__');
            }
        }
    }
})();*/
